import React, { forwardRef } from 'react';

/** The same goal-first canvas used by form and recipe creation. */
export const AuthoringGoal = forwardRef<
  HTMLDivElement,
  { title: string; children: React.ReactNode }
>(function AuthoringGoal({ title, children }, ref) {
  return (
    <div
      ref={ref}
      className="flex flex-col items-center justify-center h-full p-8 overflow-y-auto scrollbar-dark"
    >
      <div className="max-w-2xl w-full space-y-6">
        <div className="text-left">
          <h2 className="text-2xl font-bold tracking-tight text-foreground">{title}</h2>
        </div>
        {children}
      </div>
    </div>
  );
});
